export function isAndroid(): boolean {
  let userAgent = window.navigator.userAgent;
  userAgent = userAgent.toLowerCase();
  return userAgent.indexOf('android') > -1;
}

export function isIos(): boolean {
  const userAgent = window.navigator.userAgent || '';
  const isAppleDevice = /iPad|iPhone|iPod/.test(userAgent);
  const isTouchMac =
    /Macintosh/.test(userAgent) && window.navigator.maxTouchPoints > 1;

  return isAppleDevice || isTouchMac;
}

export function browserRedirect(redirect_url: string): void {
  window.location.href = redirect_url;
}

export function iosDismiss(): void {
  window.location.href = 'ios://webToNativeCall/dismiss';
}

export function isMinWidth(width: 'sm' | 'md' | 'lg'): boolean {
  const widthMap: Record<'sm' | 'md' | 'lg', number> = {
    sm: 640,
    md: 768,
    lg: 1024,
  };
  if (typeof window !== 'undefined') {
    return window.matchMedia(`(min-width: ${widthMap[width]}px)`).matches;
  }
  return false;
}
